<template>
  <div style="font-weight: bold; font-size: 20px">Entitlements</div>
  <v-divider class="mt-3" />
  <div class="entitlement-container">
    <div
      class="entitlement"
      v-for="entitlement in entitlements"
      :key="entitlement.id"
      :style="entitlementStyling(entitlement)"
      :title="entitlement.name">
      <v-icon>{{ entitlementIcon(entitlement) }}</v-icon>
      {{ entitlement.code }}
    </div>
  </div>
</template>
<script setup>
const props = defineProps(['entitlements']);

const defaultColor = 'darkgrey';

function entitlementStyling(entitlement) {
  return {
    backgroundColor: entitlement.metadata.color
      ? entitlement.metadata.color
      : defaultColor,
  };
}

function entitlementIcon(entitlement) {
  return entitlement.metadata.icon ? entitlement.metadata.icon : 'mdi-medal';
}
</script>

<style scoped>
.entitlement-container {
  margin-top: 10px;
  display: flex;
  gap: 10px;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px;
}

.entitlement {
  cursor: default;
  font-size: 0.8em;
  border-radius: 5px;
  padding: 10px;
}
</style>
